import {Navbar,Footer} from '../components';
import {Link} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import * as Icon from 'react-bootstrap-icons';
import { LineChart,BarChart,Bar,Rectangle, Line,AreaChart,Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";



const SalesProjection=()=>{
    if(localStorage.getItem('branchID')===null){
        window.location.replace('/');
    }

    const [inputData,setInputData]=useState([]);
    const [fYear,setfYear]=useState('');
    const [projectionData,setProjectionData]=useState([]);

    const getData = async () => {
        var date = new Date();
        var aMonth = date.getMonth()+1; // returns 0 - 11
        var aYear= date.getFullYear();
        if(aMonth<=6){aYear=aYear-1}
        setfYear(aYear);

        const response=await axios.get(configData.SERVER_URL+`/salesProjection/${localStorage.getItem('branchID')}/${aYear}`);
        setProjectionData(response.data);
    };

    useEffect(() => {
        
        getData();

    }, []);

    const handleInput=(e)=>{
        const {name,value}=e.target; 
        setInputData({...inputData,[name]:value});  
    }

    const handleSubmit=async(e)=>{
        e.preventDefault();
        const allinputData={organization:inputData.organization, opportunity:inputData.opportunity, 
            opportunityValue:inputData.opportunityValue, unit:inputData.unit,
            opperGain:inputData.opperGain,opperGainValue:inputData.opperGainValue,fYear:fYear,
            branchID:localStorage.getItem('branchID')}

        let res=await axios.post(configData.SERVER_URL+'/salesProjection',allinputData);
        if(res.status===200){
          if(res.data===1){
            alert('Successfully Updated');
            getData();
          }
        } else{
          alert('System Error');
        } 
    }

    return(
        <>
        <div className='container'>
        <Navbar />
        
        <form onSubmit={handleSubmit}>
        <div className="row well py-5">
        <div className="col-xl-12 col-sm-12 mb-3">
            <div className="card text-balck bg-success o-hidden h-100">
            <div className="card-header">Sales Projection Entry</div>
                <div className='card card-body'>
                <div className='row'>
                    <div className="col-lg-2">Organization
                          <input type="text" className="form-control" id="organization" name="organization" value={inputData.organization} onChange={(e)=>{handleInput(e)}} required="required"></input>
                    </div>
                    <div className="col-lg-2">Opportunity Qty
                          <input type="number" className="form-control" id="opportunity" name="opportunity" value={inputData.opportunity} onChange={(e)=>{handleInput(e)}} required="required"></input>
                    </div>
                    <div className="col-lg-2">Unit
                          <input type="text" className="form-control" id="unit" name="unit" value={inputData.unit} onChange={(e)=>{handleInput(e)}} required="required"></input>
                    </div>
                    <div className="col-lg-2">Opportunity Value
                          <input type="number" className="form-control" id="opportunityValue" name="opportunityValue" value={inputData.opportunityValue} onChange={(e)=>{handleInput(e)}} required="required" ></input>
                    </div>
                      
                    <div className="col-lg-2">Oppertunity Gain
                          <input type="number" className="form-control" id="opperGain" name="opperGain" value={inputData.opperGain} onChange={(e)=>{handleInput(e)}} required="required"></input>
                    </div>
                    <div className="col-lg-2">Oppertunity Gain Value
                          <input type="number" className="form-control" id="opperGainValue" name="opperGainValue" value={inputData.opperGainValue} onChange={(e)=>{handleInput(e)}} required="required"></input>
                    </div>

                    <div className="text-center">
                          <button class="my-4  btn btn-lg btn-info" type="submit">Save</button>
                    </div>
                    
                </div>
                </div>
            </div>
        </div>
        </div>
        </form>

        <div className="row well py-5">
        <div className="col-xl-12 col-sm-12 mb-3">
            <div className="card text-balck bg-success o-hidden h-100">
            <div className="card-header">Sales Projection Data</div>
                <div className='card card-body'>
                    <div className='table tabltable-responsive'>
                    <table class="table table-success table-hover">
                        <thead>
                        <tr align="left">
                            <th>Financial Year</th>
                            <th>Organization</th>
                            <th>Opportunity</th>
                            <th>Unit</th>
                            <th>Opportunity Gain</th>
                            <th>Achievement(%)</th>
                        </tr>
                        </thead>
                        <tbody>
                            {
                            projectionData && projectionData.length>0 && projectionData.map((data)=>
                                <tr align="left">
                                    <td>{data.fYear}</td>
                                    <td>{data.organization}</td>
                                    <td>{data.opportunity.toFixed(2).toLocaleString('en-IN')}</td>
                                    <td>{data.unit}</td>
                                    <td>{data.opperGain.toFixed(2).toLocaleString('en-IN')}</td>
                                    <td>{((data.opperGain/data.opportunity)*100).toFixed(2).toLocaleString('en-IN')}</td>
                                </tr>
                            )}
                        </tbody>
                    </table> 
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        </div>
        </div>
        </>
    )
}

export default SalesProjection;